import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

export interface StoreProps {
    activeDrawerId: string;
    noBackdrop?: boolean;
}
const initialState: StoreProps = {
    activeDrawerId: '',
    noBackdrop: false,
};

const temporaryDrawer = createSlice({
    name: 'temporaryDrawer',
    initialState,
    reducers: {
        toggleTemporaryDrawer: {
            reducer: (state, payload: PayloadAction<{ activeDrawerId: string }>) => {
                if (state.activeDrawerId === payload.payload.activeDrawerId) {
                    state.activeDrawerId = '';
                }

                state.activeDrawerId = payload.payload.activeDrawerId;
            },
            prepare: (activeDrawerId: string) => {
                const id = nanoid();
                return { payload: { id, activeDrawerId } };
            },
        },
        setNoBackdrop: {
            reducer: (state, payload: PayloadAction<{ noBackdrop: boolean }>) => {
                state.noBackdrop = payload.payload.noBackdrop;
            },
            prepare: (noBackdrop: boolean) => {
                const id = nanoid();
                return { payload: { id, noBackdrop } };
            },
        },
        closeTemporaryDrawer(state) {
            state.activeDrawerId = '';
            state.noBackdrop = false;
        },
    },
});

export default temporaryDrawer.reducer;

export const { toggleTemporaryDrawer, setNoBackdrop, closeTemporaryDrawer } = temporaryDrawer.actions;
